'use client';
import React, { useState } from 'react';
import { Button, Text, Flex, Icon } from '@chakra-ui/react';
import { MdArrowBack, MdOutlineEmail } from 'react-icons/md';
import Logo from '../../components/logo';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../../lib/i18n/useTranslation';
export default function EmailConfirmedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <Logo />
      <Flex
        mt={3}
        alignItems="center"
        flexDirection="column"
      >
        <Flex>
          <Icon
            as={MdOutlineEmail}
            color={'fill.green'}
            boxSize={'20px'}
            mb={3}
          />
          <Text color={'fill.green'} ml={1}>{t('auth.emailConfirmed')}</Text>
        </Flex>
        <Button
          variant="greyOutline"
          leftIcon={MdArrowBack}
          onClick={() => {
            navigate('/auth/sign-in')
          }}
        >
          {t('auth.goBackSignIn')}</Button>
      </Flex>
    </>
  )
}
